import type { DropDownItem } from '@rialtic/types'

export type ValidationBody = Record<
  string,
  string | number | DropDownItem | boolean
>

export interface SplitClaimResult {
  mainClaimBody: ValidationBody
  otherClaimBody: ValidationBody | null
}

/**
 * Splits validation body into main claim and other claim based on is_other_claim flags
 * @param validBody - The form validation body containing all fields
 * @returns Object with mainClaimBody and otherClaimBody (or null if no other claims)
 */
export const splitOtherClaim = (
  validBody: ValidationBody,
): SplitClaimResult => {
  const mainClaimBody = { ...validBody }
  const otherClaimBody: ValidationBody = {}
  const otherClaimSequences: string[] = []

  for (const key in validBody) {
    if (key.startsWith('is_other_claim-') && validBody[key] === true) {
      const sequence = key.replace('is_other_claim-', '')
      otherClaimSequences.push(sequence)
    }
  }

  if (otherClaimSequences.length === 0) {
    return { mainClaimBody, otherClaimBody: null }
  }

  for (const [key, value] of Object.entries(validBody)) {
    const sequence = key.match(/-(\d+)$/)?.[1]

    if (sequence) {
      if (otherClaimSequences.includes(sequence)) {
        otherClaimBody[key] = value
        delete mainClaimBody[key]
      }
    } else if (!key.startsWith('is_other_claim-')) {
      // Copy header fields to other claim body
      otherClaimBody[key] = value
    }
  }

  // Clean up all is_other_claim flags
  for (const key in mainClaimBody) {
    if (key.startsWith('is_other_claim-')) {
      delete mainClaimBody[key]
    }
  }

  for (const key in otherClaimBody) {
    if (key.startsWith('is_other_claim-')) {
      delete otherClaimBody[key]
    }
  }

  return { mainClaimBody, otherClaimBody }
}
